import axios from 'axios'

const todayDate = new Date().toISOString().slice(0, 10)
// const todayDate = '2021-08-08'
// const statusOrder = ['SUCCESS','FINDDRIVER', 'FAIL', 'CANCELBYADMIN', 'CANCELBYDRIVER', 'DERIVERING', 'PICKUP', 'WAITING', 'PROGRESS']
// const statusOrder = ['SUCCESS', 'FINDDRIVER', 'DERIVERING']
// const statusDriver = ['WAITING', 'PICKUP', 'DELIVERY', 'OFFLINE']
// const statusRequest = { status: 'SUCCESS' }
// const querytext = `query GetStatus($status: ID!)  {
//   getStatus(status: $status) {
//     status
//     dates(filter: {date: {eq: "${todayDate}"}}) {
//       items {
//         orders {
//           items {
//             createdAt
//             deliveryFee
//             destination
//             distance
//             driverID
//             driverName
//             id
//             name
//             origin
//             phone
//             photoConfirmOrder
//             photoSuccessOrder
//             price
//             productlist
//             signOrderSuccess
//             status
//             time
//             updatedAt
//             rating {
//               commentFromDriver
//               ratingAddress
//               ratingEmployee
//               ratingOrder
//             }
//           }
//         }
//       }
//     }
//   }
// }`

const querytext = `query GetStatus($status: ID!)  {
  getStatus(status: $status) {
    status
    dates(filter: {date: {eq: "${todayDate}"}},limit: 9999) {
      items {
        orders {
          items{
            status
          }nextToken
        }
      }
    }
  }
}`
let querytextNextToken
// console.log(querytext)
// var data = JSON.stringify({
//   query: querytext,
//   variables: statusRequest
// })

// var config = {
//   method: 'post',
//   url: 'https://bp2brevnbrgkvivdv3qmktqway.appsync-api.ap-southeast-1.amazonaws.com/graphql',
//   headers: {
//     'x-api-key': 'da2-yz36pv53x5adjds5kawmesowju',
//     'Content-Type': 'application/json'
//   },
//   data: data
// }
function checNextToken (lookingStatu, _nextToken = null) {
  const _statusRequest = { status: `${lookingStatu}` }
  if (_nextToken) {
    querytextNextToken = `query GetStatus($status: ID!)  {
    getStatus(status: $status) {
      status
      dates(filter: {date: {eq: "${todayDate}"}},limit: 9999) {
        items {
          orders(nextToken:"${_nextToken}") {
            items{
              status
            }nextToken
          }
        }
      }
    }
  }`
  }
  const _data = JSON.stringify({
    query: _nextToken ? querytextNextToken : querytext,
    variables: _statusRequest
  })
  const _config = {
    method: 'post',
    url: 'https://bp2brevnbrgkvivdv3qmktqway.appsync-api.ap-southeast-1.amazonaws.com/graphql',
    headers: {
      'x-api-key': 'da2-yz36pv53x5adjds5kawmesowju',
      'Content-Type': 'application/json'
    },
    data: _data
  }
  return _config
}

async function getDataFromDB (lookingStatu) {
  const config = checNextToken(lookingStatu)
  try {
    const { data } = await axios(config)
    if (!data.data.getStatus.dates.items[0]) {
      return 'N/A'
    }
    const _temp = data.data.getStatus.dates.items[0].orders
    const firstLenght = _temp.items.length
    let secondLenght = 0
    let _checkNextToken = _temp.nextToken
    while (_checkNextToken) {
    // console.log(_temp.nextToken)
      const configNextToken = checNextToken(lookingStatu, _checkNextToken)
      const { data } = await axios(configNextToken)
      const _tempNextToken = data.data.getStatus.dates.items[0].orders
      secondLenght += _tempNextToken.items.length
      _checkNextToken = _tempNextToken.nextToken
    }
    return firstLenght + secondLenght
  } catch (error) {
    console.log(error)
  }
}

async function getActiveDriver () {
  // const findding = await getDataFromDB('FINDDRIVER')
  const delivering = await getDataFromDB('DERIVERING')
  const pickup = await getDataFromDB('PICKUP')

  // const activeDriver = findding + delivering + pickup
  const activeDriver = delivering + pickup
  return activeDriver
}

async function getIssue () {
  const cancelAdmin = await getDataFromDB('CANCELBYADMIN')
  const cancelDriver = await getDataFromDB('CANCELBYDRIVER')

  const issue = cancelAdmin + cancelDriver
  return issue
}

const initialState = {
  status: null
}

const currentStat = {
  namespaced: true,
  state: initialState,
  getters: {
    status: (state) => {
      return state.status
    }
  },
  mutations: {
    setStatus (state, val) {
      state.status = val
    }
  },
  actions: {
    async getStatus (context) {
      const temp = {
        'Active Driver': await getActiveDriver(),
        'Success Order': (await getDataFromDB('SUCCESS')),
        'Finding Driver': (await getDataFromDB('FINDDRIVER')),
        Delivering: (await getDataFromDB('DERIVERING')),
        'Progress Order': (await getDataFromDB('PROGRESS')),
        Issue: await getIssue()
      }
      // console.log('get temp2', temp)
      context.commit('setStatus', temp)
    }
  }

}

export default currentStat
